import {AfterViewInit, Component,  ElementRef, OnDestroy, Input, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
 
import {AuthService} from "../../shared/services/auth.service";
import {StreamsService}  from "../../shared/services/streams.service";
import {StreamProject} from "../../shared/interfaces";
import {switchMap, map, delay} from 'rxjs/operators';
import { Socket } from 'ngx-socket-io';
import {SocketStreamsControl, socketEvents} from '../../shared/services/sockets'
import {PanelVisibilityService} from '../../shared/services/panel-visibility.service'

import {VideoPlayerComponent} from '../../shared/components/video-player/video-player.component'
import {domain, protocol} from '../../shared/config';
import {  NbToastrService, NbGlobalPosition, NbDialogService } from '@nebular/theme';
import {outputLimitText} from '../../overview-restreams-page/srt-reasons';
 import {StreamSettingsComponent} from '../../shared/components/stream-settings/stream-settings.component';
 import {StreamInfoComponent} from '../../shared/components/stream-settings/stream-info/stream-info.component';
 import {StreamRestreamsModalComponent} from '../restreams-modal/restreams-modal.component';
 import {visibilityPanelAnimation} from "../../shared/classes/visibility-panel.animation";
 
@Component({
  selector: 'app-stream-overview',
  templateUrl: './stream-overview.component.html',
  styleUrls: ['./stream-overview.component.scss'],
  animations: [visibilityPanelAnimation]
})
export class StreamOverviewComponent implements OnInit, OnDestroy{


  @ViewChild('video') videoComponent:VideoPlayerComponent 
  @ViewChild('infoComponent') infoComponent:StreamInfoComponent 
  
  @Input() stream: StreamProject;

  @ViewChild('recordCheckBox') recordCheckBox: ElementRef;
 
  recordVideo: boolean = false;
  /*stream$:Observable<StreamProject> */
  domain: any = {
    name: domain, protocol
  }
  togglePublish$:any
  rejectStreamSignal$
  updateDownloadInfo$:any
  projectId: string
  streamSrc: string
  previewSrc: string
  frameCode: string
  frameCodeLink: string
  frameChatCode: string
  frameChatCodeLink: string
  streamIsRunning: boolean = false
  publish: boolean
  hasSignal: boolean = false
  viewersQuantity: any = 0
  initialLoading: boolean = true
  signalInfo:any = false
  settingsModalInstance: any = null
  restreams: any = []
  linkSignalInputDisabled: boolean = false
  linkSignalInputError: boolean = false
  linkSignalButtonsDisabled: boolean = false
  linkSignalIsRunning: boolean = false
  linkSignalInputValue: string = ''
  streamsControlBtnsLoading:boolean = false
  signalMode:number = 1
  rtmpKeyVisible:boolean = false;
  readyToStream = null
  fsProccessing: boolean = false

   constructor(
    public streamsService: StreamsService,
    public route:  ActivatedRoute,
    private socket: SocketStreamsControl,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    public authService: AuthService,
    public panelVisibility: PanelVisibilityService
    ){  }


  ngOnInit() { 
 
    this.initRestreamsFromData()
    this.publish = this.stream.publish

     this.frameCodeLink = `${this.domain.protocol}${this.domain.name}/watch-embed?v=${this.stream.publicIdentity}`
     this.frameCode = `<iframe livestreamEmbed src="${this.frameCodeLink}" width="560" height="315" frameborder="0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  webkitallowfullscreen mozallowfullscreen  allowfullscreen></iframe> `

     this.frameChatCodeLink = `${this.domain.protocol}${this.domain.name}/chat-embed?v=${this.stream.publicIdentity}`

     this.frameChatCode = `<iframe livestreamEmbedChat src="${this.frameChatCodeLink}" width="350" height="550" frameborder="0" allowfullscreen></iframe> `

    this.previewSrc = `/preview/live/`+ this.stream.streamKey+"-"+this.stream.secretKey+'.flv'
 
    this.streamSrc =  this.previewSrc

    this.projectId = this.stream._id


    this.socket.on('connect', ()=>{

      this.socket.emit('onJoin', {

          data :  this.projectId,
	  publicId: this.stream.publicIdentity

      })

          this.initialLoading = false 

    })


    this.socket.on(socketEvents.streamStatusChanged, this.streamStatusChanged.bind(this))
    this.socket.on(socketEvents.viewersChanged, this.viewersChanged.bind(this))
    this.socket.on('restreamEvent', this.onRestreamEvent.bind(this))
    this.socket.on('linkSignalEvent', this.onLinkSignalEvent.bind(this))
    this.socket.connect()
 	 
  }


//linksignal

 
    setSignalMode(m:number){
	this.signalMode = m
   }

   startLinkSignal(){

	 if(this.isUrlValid(this.linkSignalInputValue)){
		 
		 this.linkSignalButtonsDisabled = false
		this.socket.emit('startLinkSignal',{link:this.linkSignalInputValue,user:this.stream.user, ident:this.stream._id, rtmp: `${this.stream.streamKey}-${this.stream.secretKey}`})

	 }else{

	 	this.linkSignalInputError = true
	 }


   }



  openEditInfo(){

	this.infoComponent.openEdit()
}


   stopLinkSignal(){
	 
	 this.linkSignalButtonsDisabled = true
	this.socket.emit('stopLinkSignal',{link:this.linkSignalInputValue,user:this.stream.user, ident:this.stream._id, rtmp: `${this.stream.streamKey}-${this.stream.secretKey}`})

   }


      onLinkSignalEvent(data){
		
		if(data.type === 'initialState'){

			this.linkSignalInputDisabled = true
			this.linkSignalInputValue = data.payload.link
			this.linkSignalIsRunning = true
			this.setSignalMode(2)
			this.linkSignalButtonsDisabled = false
			//this.stream.downloadInfo = {resolutions:[], size:0}

		  return
		}

	
		if(data.type === 'stopedWithError' || data.type === 'stop'){
			this.linkSignalIsRunning = false
			this.linkSignalInputDisabled = false
			 this.linkSignalButtonsDisabled = false

		  return
		}
	       
		if(data.type === 'started'){
			this.linkSignalInputDisabled = true
			this.linkSignalInputValue = data.payload.link
			this.linkSignalIsRunning = true
			this.linkSignalButtonsDisabled = false
		
		  return
		}
	}
//

   
  isUrlValid(userInput) {

     return true;
     var res = userInput.match(/^(ftp|http|https):\/\/[^ "]+$/); 

 
    if(res == null)
        return false;
    else{ 
   
	let x = userInput.split('.')
	x = x[x.length-1].split('?')[0]
	if(x !== 'm3u8' && x !== 'mpd' && x !== 'mp4'){
		 return false;
	} /**/
        return true;
    }
  }


//end-linksignal



 
  onRestreamEvent(data){
   let restream = this.restreams.find(r=>r.id === data.payload.id)

    if(restream){
     let ev = data.payload.restreamEvent


	if(ev === 'cancelStartByTariff'){
	   restream.status = false
	   this.toastrService.show(outputLimitText(data.payload.used, data.payload.limit), 'Канал не запущено', {status: 'warning', position: <NbGlobalPosition>'bottom-end', duration: 8000})
	}

      if(ev === 'started'){
         restream.status = true
         restream.colorType = 'success'
      }else{
        restream.status = false
        restream.colorType = 'primary'

	
      } 
    }
  }



  restreamsSavedCb(data){ 
    
      let restreams  = data.map(restream=>{

        let currentRestream = this.restreams.find(r=>r.id === restream.id)  
            return {
              ...restream,
              status: currentRestream ? currentRestream.status : false,
              colorType: currentRestream ? currentRestream.colorType : 'primary'

            }
      })
 
      
      this.restreams = restreams
      if(this.hasSignal){

        this.socket.emit('restreamAction',{
          type: 'changeData',
          restreams: data
        })
      }

  }



  restreamStatusChanged(checked, id){
    this.socket.emit('restreamAction', {
      type:checked ? 'on' : 'off',
      restreamId: id
    })
  }

  initRestreamsFromData(){

    let r = this.stream.restreams.map(r=>{return {...r}})
    for (let restream of this.restreams){
      let item = r.find(rs=>rs.id === restream.id)
      
      if(item){
        item.status = restream.status || false
        item.colorType = restream.colorType || 'primary'
      }
     
    }

    this.restreams = r
  }

  onChangeRecord(target){
    
    this.recordVideo = target.checked
  }
  viewersChanged(data){

      this.viewersQuantity = data

  }


  streamStatusChanged(data){



   if(data?.type === 'readyToStreamChanged'){

	if(data?.payload?.readyToStream !== undefined){
		this.readyToStream = data.payload.readyToStream
	}
	return
   }

   if(data?.type === 'fsLoadingStatus'){
   if(data?.payload?.fsProccess){
		this.streamsControlBtnsLoading = true
		this.fsProccessing = true
	} else {
	  this.streamsControlBtnsLoading = false
	  this.fsProccessing = false
   
	   setTimeout(()=>{  
		this.updateDownloadInfo()
	},1000)

	}
    }

   if(data?.type === socketEvents.signalConnected){

    this.hasSignal = true
   
    this.signalInfo = data.payload.info
    this.videoComponent.start()

    if(data?.payload?.readyToStream !== undefined){
	this.readyToStream = data.payload.readyToStream
    }

    if(data.payload.restreams?.length){

      for (let re of data.payload.restreams){
        let item = this.restreams.find(r=>r.id === re.id)
        if(item){
          item.status = re.isRunning 
          item.colorType = re.isRunning ? 'success' : 'primary'
        }
      }

    }


 

        return
   } else 
   if(data?.type === socketEvents.signalDisconnected){

    this.hasSignal = false
    this.signalInfo = false


    this.videoComponent.start()

 
    for (let restream of this.restreams){
      
        restream.status =   false
        restream.colorType = 'primary'
     
     
    }


    return
   } else



 if(data?.type === 'liveTurnedBack'){
 
  
    this.streamSrc = this.previewSrc
    this.streamIsRunning = true
    
       this.videoComponent.setSource({src: this.streamSrc})

	if(data?.payload?.readyToStream !== undefined){
		this.readyToStream = data.payload.readyToStream
	}
    return
   }else
   if(data?.type === socketEvents.previewStarted){
 
  
    this.streamSrc = this.previewSrc
    this.streamIsRunning = false
    
this.videoComponent.setSource({src: this.streamSrc})

	if(data?.payload?.readyToStream !== undefined){
		this.readyToStream = data.payload.readyToStream
	}
    return
   } else 
   if(data?.type === socketEvents.streamStarted){

 
    this.recordVideo = data.payload.record

	this.stream.downloadInfo = {resolutions:[], size:0}

  
    this.streamIsRunning = true
   
    return
   } else if(data?.type === socketEvents.streamStoped){
 

    	this.streamIsRunning = false

    return
   }


  }


  startTranslation(){
 

    this.socket.emit(socketEvents.startTranslation, {
      
      projectId: this.projectId,
      record: this.recordCheckBox.nativeElement.checked
    
    })
  }
 




 
  rejectSignal(ref){
	ref.close()


    this.rejectStreamSignal$ = this.streamsService
    .rejectStreamSignal(this.stream._id)
	     .subscribe((dt:any)=>{
	  
		    this.toastrService.show('',`З'єднання розірвано`,{
		      status: 'primary',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end'
			})

	    }, ()=>{
		 		
		    this.toastrService.show('','Сталася помилка',{
		      status: 'danger',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end'
			})
	    })
  }






  stopTranslation(ref){
	ref.close()
    this.socket.emit(socketEvents.stopTranslation, this.projectId)
  }

   openStopModal(content){

    this.dialogService.open(content,{hasScroll: true} )
  }

  openInfoModal(content){

    this.dialogService.open(content,{

      closeOnBackdropClick: true,
      hasScroll: true 
    }  )
  }
 
   ngOnDestroy() { 

    // 
 	 
       this.socket.disconnect()
	
	this.socket.removeAllListeners('connect')
	this.socket.removeAllListeners(socketEvents.streamStatusChanged)
	this.socket.removeAllListeners(socketEvents.viewersChanged)

	this.socket.removeAllListeners('restreamEvent')
	this.socket.removeAllListeners('linkSignalEvent') 
		
     /*  this.socket.removeAllListeners()  */

    if(this.updateDownloadInfo$){this.updateDownloadInfo$.unsubscribe()}
   }
 


   showToastCopyClipboard(text){

    this.toastrService.show('',text,{
      status: 'primary',
      icon: '',
      position: <NbGlobalPosition>'bottom-end'
        })
   }

   

  openRestreamsSettings(){

	this.dialogService.open(StreamRestreamsModalComponent, {
	      
	      context: {
		stream: this.stream, 
		onRestreamSaved: this.restreamsSavedCb.bind(this)
	      },
	    });
 }



   openSettings(chatMode = false){
 
     this.dialogService.open(StreamSettingsComponent, {
      dialogClass: 'settings-modalsscrollable-container',
      context: {
        stream: this.stream, 
        hasSignal: this.hasSignal,
	socket: this.socket,
        chatMode
 
      },
    });

	
 

   }
/**/
   getRestreamLabel(restr:string){
		let url = restr.split('://')[1];
		url = url.split('/')[0];
		url = url.split(':')[0];
		return 	url;
	}



	
  togglePublish(){

 
    this.togglePublish$ = this.streamsService
    .updatePublish(this.stream._id,this.publish)
	     .subscribe((stream : StreamProject)=>{
 
	      this.publish = stream.publish
	     this.stream.publish = stream.publish

	    }, ()=>{
	      this.publish = this.stream.publish
	    })
	 
  }


	updateDownloadInfo(){

	if(this.updateDownloadInfo$){this.updateDownloadInfo$.unsubscribe()}
    this.updateDownloadInfo$ = this.streamsService
    .updateStreamDownloadInfo(this.stream._id)
	     .subscribe((info : any)=>{
	  		this.stream.downloadInfo = info

	    }, ()=>{
 
	    })

	}

  
}
